import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default class FeatureExplore extends Component {
  static propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stroke: PropTypes.string,
    fill: PropTypes.string,
    svgProps: PropTypes.object
  };

  static defaultProps = {
    className: "",
    size: "inherit",
    stroke: "currentColor",
    fill: "currentColor",
    svgProps: {}
  };

  get defaultHeight() {
    return 32;
  }

  get defaultWidth() {
    return 32;
  }

  get size() {
    return this.props.size;
  }

  get width() {
    if (this.size === null || this.size === "inherit") return null;
    if (this.size === "default") return this.defaultWidth;
    return this.size;
  }

  get height() {
    if (this.size === null || this.size === "inherit") return null;
    if (this.size === "default") return this.defaultHeight;
    return this.size;
  }

  get viewBox() {
    return "0 0 32 32";
  }

  get classes() {
    const { className } = this.props;
    return classnames("manicon-svg", className);
  }

  get fill() {
    return this.props.fill;
  }

  get stroke() {
    return this.props.stroke;
  }

  render() {
    const baseSvgProps = {
      xmlns: "http://www.w3.org/2000/svg",
      className: this.classes,
      width: this.width,
      height: this.height,
      viewBox: this.viewBox,
      fill: this.fill
    };

    const svgProps = Object.assign(baseSvgProps, this.props.svgProps);

    return (
      <svg {...svgProps}>
        <path d="M15.9995,9.5 C17.2983389,9.5 18.3515,10.553554 18.3515,11.852 C18.3515,11.9356015 18.3471403,12.0181866 18.3386359,12.0995398 L20.4557815,13.0795602 C21.4160067,12.1576308 22.7199843,11.591 24.1565,11.591 C27.1076424,11.591 29.5005,13.9838576 29.5005,16.935 C29.5005,19.886813 27.1079718,22.279 24.1565,22.279 C21.2896718,22.279 18.9512129,20.0233898 18.8184485,17.1894946 C17.9450046,16.9168929 16.9880231,16.7724 16.0002,16.7724 C15.0116196,16.7724 14.0545444,16.9168594 13.1810597,17.1895845 C13.0492495,20.0230791 10.710177,22.279 7.844,22.279 C4.89185763,22.279 2.5,19.8871424 2.5,16.935 C2.5,13.9835282 4.89218702,11.591 7.844,11.591 C9.27969089,11.591 10.583253,12.1573155 11.5434604,13.0787204 L13.6613616,12.0995066 C13.6528589,12.0181629 13.6485,11.9355889 13.6485,11.852 C13.6485,10.5537504 14.7014646,9.5 15.9995,9.5 Z M24.1565,12.591 C21.7570037,12.591 19.8125,14.535781 19.8125,16.935 C19.8125,19.3348576 21.7566424,21.279 24.1565,21.279 C26.555719,21.279 28.5005,19.3344963 28.5005,16.935 C28.5005,14.5361424 26.5553576,12.591 24.1565,12.591 Z M7.844,12.591 C5.4445037,12.591 3.5,14.535781 3.5,16.935 C3.5,19.3348576 5.44414237,21.279 7.844,21.279 C10.243219,21.279 12.188,19.3344963 12.188,16.935 C12.188,14.5361424 10.2428576,12.591 7.844,12.591 Z M26.3630406,14.8900373 C26.5507968,15.0925273 26.5388528,15.4088844 26.3363627,15.5966406 C26.1338727,15.7843968 25.8175156,15.7724528 25.6297594,15.5699627 C24.8749483,14.7559194 23.6041877,14.7078915 22.7903486,15.4616537 C21.9768054,16.2159428 21.9287768,17.4867205 22.6832204,18.3012313 C22.8708695,18.5038206 22.8587581,18.8201713 22.6561687,19.0078204 C22.4535794,19.1954695 22.1372287,19.1833581 21.9495796,18.9807687 C20.8200423,17.7613001 20.891974,15.8580763 22.1106456,14.7281663 C23.3296291,13.5991668 25.2327935,13.6710963 26.3630406,14.8900373 Z M10.0505406,14.8900373 C10.2382968,15.0925273 10.2263528,15.4088844 10.0238627,15.5966406 C9.82137271,15.7843968 9.50501562,15.7724528 9.31725939,15.5699627 C8.56244834,14.7559194 7.29168766,14.7078915 6.47784861,15.4616537 C5.66430544,16.2159428 5.61627682,17.4867205 6.37072039,18.3012313 C6.55836949,18.5038206 6.54625805,18.8201713 6.34366874,19.0078204 C6.14107943,19.1954695 5.8247287,19.1833581 5.63707961,18.9807687 C4.50754227,17.7613001 4.57947397,15.8580763 5.79814559,14.7281663 C7.0171291,13.5991668 8.92029348,13.6710963 10.0505406,14.8900373 Z M18.0213712,13.0547634 C17.6110926,13.7435018 16.8591805,14.205 15.9995,14.205 C15.1403512,14.205 14.3887051,13.7434157 13.9785455,13.0546761 L12.2203598,13.8675413 C12.6900054,14.5363069 13.010259,15.3175889 13.1326171,16.1628836 C14.0323293,15.9061856 15.0031141,15.7724 16.0002,15.7724 C16.9970655,15.7724 17.9681536,15.9063409 18.8702883,16.161798 C18.9901672,15.3176478 19.3102255,14.5365184 19.7796268,13.867866 Z M15.9995,10.5 C15.2539164,10.5 14.6485,11.1058682 14.6485,11.852 C14.6485,12.5990188 15.2538036,13.205 15.9995,13.205 C16.7460835,13.205 17.3515,12.5991318 17.3515,11.852 C17.3515,11.1057552 16.7459706,10.5 15.9995,10.5 Z" />
      </svg>
    );
  }
}
